import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _taggedTemplateLiteral from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// @ts-ignore

/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
var defaultOptions = {};
/** All built-in and custom scalars, mapped to their actual values */

export var OfferDataFragmentDoc = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    fragment OfferData on Offer {\n  id\n  paymentMethods\n  bnplPaymentMethods {\n    type\n    label\n  }\n  purchasableQuantity\n  purchaseLimit\n  warranty {\n    type\n    description\n  }\n  shipping {\n    soldByCatch\n    dispatchNotice {\n      message\n      type\n    }\n    dropshipDisclaimer {\n      template\n      placeholders {\n        id\n        text\n        url\n      }\n      default\n    }\n    onePassDisclaimer {\n      template\n      placeholders {\n        id\n        text\n        url\n      }\n      default\n    }\n    freeShippingDisclaimer\n    itemLocation\n    isFBC\n  }\n  seller {\n    id\n    name\n    slug\n    rating {\n      percentage\n      badge\n    }\n  }\n  freeShipping\n  clubExclusive\n  clubFreeShipping\n  priceTag {\n    priceDiscount {\n      label\n      percentageLabel\n      endDate\n    }\n    topLabel\n    priceLabel {\n      wasPrice {\n        amount\n      }\n      price {\n        amount\n      }\n      saving {\n        label\n        savingAmount {\n          amount\n        }\n      }\n    }\n    clubSellPrice {\n      amount\n    }\n    clubExclusive\n    enabled\n    retailPriceDisclaimer {\n      description\n    }\n  }\n  sellPrice {\n    amount\n    currency\n  }\n  badges\n}\n    "])));
export var AvailabilityTagsDocument = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    query AvailabilityTags($productId: ID!, $selectedOfferId: ID, $selectedVariantId: ID) {\n  productById(input: {id: $productId}) {\n    id\n    selectedOffer(\n      input: {selectedOfferId: $selectedOfferId, selectedVariantId: $selectedVariantId}\n    ) {\n      id\n      badges\n    }\n  }\n}\n    "])));
/**
 * __useAvailabilityTagsQuery__
 *
 * To run a query within a React component, call `useAvailabilityTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailabilityTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailabilityTagsQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      selectedOfferId: // value for 'selectedOfferId'
 *      selectedVariantId: // value for 'selectedVariantId'
 *   },
 * });
 */

export function useAvailabilityTagsQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(AvailabilityTagsDocument, options);
}
export function useAvailabilityTagsLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(AvailabilityTagsDocument, options);
}
export function useAvailabilityTagsSuspenseQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useSuspenseQuery(AvailabilityTagsDocument, options);
}
export var EventBreadcrumbDocument = gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    query EventBreadcrumb($slug: String!) {\n  eventBySlug(input: {slug: $slug}) {\n    event {\n      id\n      title\n      url\n      slug\n    }\n  }\n}\n    "])));
/**
 * __useEventBreadcrumbQuery__
 *
 * To run a query within a React component, call `useEventBreadcrumbQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventBreadcrumbQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventBreadcrumbQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */

export function useEventBreadcrumbQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(EventBreadcrumbDocument, options);
}
export function useEventBreadcrumbLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(EventBreadcrumbDocument, options);
}
export function useEventBreadcrumbSuspenseQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useSuspenseQuery(EventBreadcrumbDocument, options);
}
export var BuyBoxDocument = gql(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    query BuyBox($productId: ID!, $selectedOfferId: ID, $selectedVariantId: ID) {\n  productById(input: {id: $productId}) {\n    __typename\n    id\n    adult\n    sellable\n    title\n    slug\n    brand {\n      id\n      name\n      slug\n    }\n    ratingsSummary {\n      id\n      numberOfRatings\n      averageRating\n    }\n    assets {\n      hero {\n        id\n        url\n        altText\n      }\n      gallery {\n        id\n      }\n      sizeCharts {\n        id\n        url\n      }\n    }\n    selectedOffer(\n      input: {selectedOfferId: $selectedOfferId, selectedVariantId: $selectedVariantId}\n    ) {\n      ...OfferData\n      salesRuleOffers {\n        id\n        label\n        eventId\n        eventSlug\n        disclaimerTitle\n      }\n      variant {\n        id\n        offers {\n          id\n          seller {\n            id\n            name\n            slug\n          }\n          sellPrice {\n            amount\n            currency\n          }\n          freeShipping\n          clubFreeShipping\n          purchasableQuantity\n        }\n        variantOptionValues {\n          id\n        }\n      }\n    }\n    options {\n      id\n      name\n      values {\n        id\n        name\n      }\n    }\n    variants {\n      id\n      offers {\n        ...OfferData\n      }\n      wishlist {\n        inWishlist\n        wishlistItem {\n          id\n          productId\n          variantId\n          notify\n        }\n      }\n      sellable\n      variantOptionValues {\n        id\n      }\n      limitedQuantityRemaining\n    }\n    category {\n      id\n      name\n    }\n    personalisedFields {\n      id\n      name\n      label\n      elementType\n      attributes {\n        __typename\n        ... on PersonalisedSelectAttributes {\n          required\n          optionAttributes {\n            name\n            label\n          }\n        }\n        ... on PersonalisedTextAttributes {\n          required\n          minlength\n          maxlength\n        }\n        ... on PersonalisedEmailAttributes {\n          required\n        }\n        ... on PersonalisedNumberAttributes {\n          required\n          min\n          max\n        }\n      }\n    }\n    inPromotions {\n      id\n      title\n      url\n    }\n  }\n}\n    ", ""])), OfferDataFragmentDoc);
/**
 * __useBuyBoxQuery__
 *
 * To run a query within a React component, call `useBuyBoxQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuyBoxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuyBoxQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      selectedOfferId: // value for 'selectedOfferId'
 *      selectedVariantId: // value for 'selectedVariantId'
 *   },
 * });
 */

export function useBuyBoxQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(BuyBoxDocument, options);
}
export function useBuyBoxLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(BuyBoxDocument, options);
}
export function useBuyBoxSuspenseQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useSuspenseQuery(BuyBoxDocument, options);
}
export var ChristmasDeliveryDocument = gql(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    query ChristmasDelivery($postcode: String!, $offerId: ID!) {\n  christmasDelivery(input: {postcode: $postcode, offerId: $offerId}) {\n    __typename\n    ... on ChristmasDeliveryData {\n      postcode\n      deliveryMessage\n      tooltip\n      showTooltip\n      tracking {\n        category\n        action\n        label\n        property\n      }\n    }\n    ... on UserError {\n      message\n    }\n  }\n}\n    "])));
/**
 * __useChristmasDeliveryQuery__
 *
 * To run a query within a React component, call `useChristmasDeliveryQuery` and pass it any options that fit your needs.
 * When your component renders, `useChristmasDeliveryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChristmasDeliveryQuery({
 *   variables: {
 *      postcode: // value for 'postcode'
 *      offerId: // value for 'offerId'
 *   },
 * });
 */

export function useChristmasDeliveryQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(ChristmasDeliveryDocument, options);
}
export function useChristmasDeliveryLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(ChristmasDeliveryDocument, options);
}
export function useChristmasDeliverySuspenseQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useSuspenseQuery(ChristmasDeliveryDocument, options);
}
export var ProductByIdDocument = gql(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    query ProductById($productId: ID!, $selectedOfferId: ID, $selectedVariantId: ID, $previewHash: String) {\n  productById(input: {id: $productId}) {\n    id\n    title\n    sellable\n    slug\n    adult\n    description\n    footer\n    metaURLs {\n      alternate {\n        locale\n        media\n        url\n      }\n      canonical {\n        locale\n        media\n        url\n      }\n    }\n    ratingsSummary {\n      id\n      numberOfRatings\n      averageRating\n      breakdown {\n        rating\n        percentage\n        total\n      }\n    }\n    assets {\n      hero {\n        id\n        url\n      }\n      gallery {\n        __typename\n        id\n        url\n        altText\n        ... on Image {\n          width\n          height\n        }\n      }\n      sizeCharts {\n        id\n      }\n    }\n    brand {\n      id\n      name\n      slug\n    }\n    specifications\n    selectedOffer(\n      input: {selectedOfferId: $selectedOfferId, selectedVariantId: $selectedVariantId}\n    ) {\n      id\n      clubExclusive\n      badges\n      sellPrice {\n        amount\n        currency\n      }\n      purchasableQuantity\n      seller {\n        id\n        name\n      }\n      retailPriceDisclaimer {\n        description\n      }\n      conditionCode\n      variant {\n        id\n      }\n    }\n    options {\n      id\n    }\n    category {\n      id\n      name\n      level\n      leaf\n      slug\n      parent {\n        id\n        name\n        level\n        leaf\n        slug\n        parent {\n          id\n          name\n          level\n          leaf\n          slug\n          parent {\n            id\n            name\n            level\n            leaf\n            slug\n            parent {\n              id\n              name\n              level\n              leaf\n              slug\n              parent {\n                id\n                name\n                level\n                leaf\n                slug\n                parent {\n                  id\n                  name\n                  level\n                  leaf\n                  slug\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    visible(input: {previewHash: $previewHash})\n  }\n}\n    "])));
/**
 * __useProductByIdQuery__
 *
 * To run a query within a React component, call `useProductByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductByIdQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      selectedOfferId: // value for 'selectedOfferId'
 *      selectedVariantId: // value for 'selectedVariantId'
 *      previewHash: // value for 'previewHash'
 *   },
 * });
 */

export function useProductByIdQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(ProductByIdDocument, options);
}
export function useProductByIdLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(ProductByIdDocument, options);
}
export function useProductByIdSuspenseQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useSuspenseQuery(ProductByIdDocument, options);
}
export var ProductReviewsDocument = gql(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    query ProductReviews($productId: ID!, $offset: Int, $limit: Int, $rating: Int) {\n  productReviews(\n    input: {productId: $productId, offset: $offset, limit: $limit, rating: $rating}\n  ) {\n    reviews {\n      id\n      rating\n      comment\n      helpful {\n        positiveCount\n        totalCount\n        customerHelpfulFeedback\n      }\n      date\n      author\n      customerOwnsReview\n    }\n  }\n}\n    "])));
/**
 * __useProductReviewsQuery__
 *
 * To run a query within a React component, call `useProductReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductReviewsQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      rating: // value for 'rating'
 *   },
 * });
 */

export function useProductReviewsQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(ProductReviewsDocument, options);
}
export function useProductReviewsLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(ProductReviewsDocument, options);
}
export function useProductReviewsSuspenseQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useSuspenseQuery(ProductReviewsDocument, options);
}
export var MarkReviewHelpfulDocument = gql(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    mutation markReviewHelpful($input: MarkReviewHelpfulInput!) {\n  markReviewHelpful(input: $input) {\n    __typename\n    ... on ProductReview {\n      id\n      helpful {\n        customerHelpfulFeedback\n      }\n    }\n    ... on UserError {\n      message\n    }\n    ... on UnauthorisedUserError {\n      message\n    }\n  }\n}\n    "])));

/**
 * __useMarkReviewHelpfulMutation__
 *
 * To run a mutation, you first call `useMarkReviewHelpfulMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkReviewHelpfulMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markReviewHelpfulMutation, { data, loading, error }] = useMarkReviewHelpfulMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkReviewHelpfulMutation(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useMutation(MarkReviewHelpfulDocument, options);
}